import { getUtmParams } from './utmTracker';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://tnjvdswykmzvxcwfoycj.supabase.co';
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  '';

interface NavigatorWithConnection extends Navigator {
  connection?: { effectiveType?: string };
}

const navigationStartTimes = new Map<string, number>();

export const initPageViewTimer = () => {
  const page = window.location.pathname;
  navigationStartTimes.set(page, performance.now());
};

const SESSION_SEEN_KEY = 'pv_session_seen';

const isNewSession = (): boolean => {
  try {
    const seen = sessionStorage.getItem(SESSION_SEEN_KEY);
    if (!seen) {
      sessionStorage.setItem(SESSION_SEEN_KEY, '1');
      return true;
    }
    return false;
  } catch {
    return true;
  }
};

export const reportPageView = (page: string) => {
  try {
    const nav = navigator as NavigatorWithConnection;
    const navStart = navigationStartTimes.get(page);
    const loadTime = navStart ? Math.round(performance.now() - navStart) : null;
    navigationStartTimes.delete(page);

    const utm = getUtmParams();

    const payload = {
      page,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      connection_type: nav.connection?.effectiveType || null,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      load_time_ms: loadTime,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      is_new_session: isNewSession(),
    };

    const url = `${SUPABASE_URL}/functions/v1/log-page-view`;
    const body = JSON.stringify(payload);

    const requestInit: RequestInit = {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY ? { apikey: SUPABASE_ANON_KEY } : {}),
      },
      body,
    };

    fetch(url, requestInit).catch(() => {
      setTimeout(() => {
        fetch(url, requestInit).catch(() => {});
      }, 800);
    });
  } catch {
    // never throw from page view reporter
  }
};
